import { apiClient } from './client.js'
import type { Poll, CreatePollVoteRequest, PollVote, CreatePollExportRequest } from '../models/polls.js'

export async function getPolls(options?: { signal?: AbortSignal }): Promise<Poll[]> {
  const response = await apiClient.get<Poll[]>('/v1/polls', { withAuth: true, signal: options?.signal })

  if (response) {
    return response
  }

  throw new Error('Failed to get polls')
}

export async function getPoll(pollId: string, options?: { signal?: AbortSignal }): Promise<Poll> {
  const response = await apiClient.get<Poll>(`/v1/polls/${pollId}`, { signal: options?.signal })

  if (response) {
    return response
  }

  throw new Error('Failed to get poll')
}

export async function createPollVote(
  pollId: string,
  payload: CreatePollVoteRequest,
  options?: { signal?: AbortSignal },
): Promise<PollVote> {
  const response = await apiClient.post<PollVote>(`/v1/polls/${pollId}/votes`, payload, { signal: options?.signal })

  if (response) {
    return response
  }

  throw new Error('Failed to create poll vote')
}

export async function createPollExport(
  payload: CreatePollExportRequest,
  options?: { signal?: AbortSignal },
): Promise<void> {
  await apiClient.post('/v1/polls/exports', payload, { withAuth: true, signal: options?.signal })
}

